"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllRecords = void 0;
const tslib_1 = require("tslib");
const getAllRecords = (query, getFunc, maxNumFetches = 100) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    let hasMore = true;
    let skip = (_a = query.skip) !== null && _a !== void 0 ? _a : 0;
    let numFetches = 0;
    const limit = (_b = query.limit) !== null && _b !== void 0 ? _b : 10;
    const records = [];
    while (hasMore && numFetches < maxNumFetches) {
        const response = yield getFunc(Object.assign(Object.assign({}, query), { limit, skip }));
        hasMore = response.more;
        skip += response.records.length;
        numFetches++;
        records.push(...response.records);
    }
    return records;
});
exports.getAllRecords = getAllRecords;
//# sourceMappingURL=index.js.map